export default {
  left_column: {
    title: 'Check Balance',
    description:
      'Enter your gift card code to check the remaining balance. The code can be found on your gift card PDF.',
  },
  title: 'Check Gift Card Balance',
  subtitle: 'Enter a gift card code to check its current balance',
  error: {
    title: 'Gift has not been found!',
    description: 'Please enter a valid gift card code.',
  },
  gift_card: {
    title: 'Gift card has been found!',
    balance: 'Balance',
    value: 'Value',
    expires_at: 'Expires at',
  },
  form: {
    code: {
      label: 'Gift Card Code',
    },
  },
  buttons: {
    check_balance: 'Check balance',
  },
};
